/* TODO: Refactor this file to generate dates by traversing filtered feasibility object.keys
 * (eg. don't generate completedByUserUuid & status).
 * We can probably leverage C:\Users\jwcom\Desktop\Kana\web\src\route\shared\projects\project\overview\components\StandardSpecificSection\components\RenderComponent.tsx
 * to do this, we will need to remove the expression interpreter / schema related bits from it
 * Will create a shared compenent for all dates sections for this
 */

import { ProjectDatesConstants } from "../../../../constants";
import { ProjectPhaseStatus } from "../../../../models";
import { Column, DatePicker, KanaTooltip, Row } from "../../../../widget";
import { EditDatesPanelBanner } from "../EditDatesPanelBanner";
import { DateSectionProps } from "../models";

const START_LABEL = "Phase start date";
const END_LABEL = "Phase end date";
export const FeasibilitySection = ({
  dates,
  handleUpdateProjectDates,
  hasDateError,
}: DateSectionProps): JSX.Element => {
  return (
    <>
      <Row spacingV="m">
        <Column span={12}>
          <p className="body01">Feasibility</p>
        </Column>
      </Row>
      <Row spacingV="l">
        <Column span={12}>
          <p className="body1">
            Enter key dates to help structure your workflow and align with your broader roadmap. These can be either
            confirmed or estimated, and can be updated as the project develops.
          </p>
        </Column>
      </Row>
      <Row spacingV="xl">
        <Column span="4_half">
          <DatePicker
            label={START_LABEL}
            value={dates.feasibility?.start}
            onChange={(date) => handleUpdateProjectDates(date, "feasibility.start")}
            hasError={hasDateError("feasibility.start")}
            tooltip={
              <KanaTooltip
                tooltipHeader=""
                tooltipText={ProjectDatesConstants.FEASIBILITY_START_TOOLTIP_TEXT}
                hasError={hasDateError("feasibility.start")}
              />
            }
          />
        </Column>
        <Column offset="1_half" span="4_half">
          <DatePicker
            label={END_LABEL}
            value={dates.feasibility?.end}
            onChange={(date) => {
              handleUpdateProjectDates(date, "feasibility.end");
              handleUpdateProjectDates(
                date !== undefined ? new Date(new Date(date).setDate(date.getDate() + 1)) : undefined,
                "design.start"
              );
            }}
            hasError={hasDateError("feasibility.end")}
            tooltip={
              <KanaTooltip
                tooltipHeader=""
                tooltipText={ProjectDatesConstants.FEASIBILITY_END_TOOLTIP_TEXT}
                hasError={hasDateError("feasibility.end")}
              />
            }
          />
        </Column>
      </Row>
      <EditDatesPanelBanner
        phaseStatus={dates.feasibility.status as ProjectPhaseStatus}
        phaseEndDate={dates.feasibility.end}
      />
    </>
  );
};
